import React from 'react';
import './css/About.css';

const About: React.FC = () => {
    return (
        <div className="history-page">
            <div className="vision-hero-section">
                <div className="vision-hero-content">
                    <h1 className="vision-main-title">Бидний Түүх</h1>
                    <p className="vision-hero-subtitle">
                        Монгол Авто Тээврийн Нийгэмлэгийн үүсгэн байгуулагдсан түүх, хөгжлийн замнал
                    </p>
                </div>
            </div>

            <div className="history-content">
                <div className="container">
                    <div className="history-timeline">
                        <div className="timeline-item">
                            <div className="timeline-year">1990</div>
                            <div className="timeline-content">
                                <h3>Үүсгэн байгуулагдсан</h3>
                                <p>Монгол Авто Тээврийн Нийгэмлэг нь 1990 онд үүсгэн байгуулагдаж, улсын хөгжилд хувь нэмрээ оруулах зорилгоор ажиллагаагаа эхлүүлсэн.</p>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-year">1995</div>
                            <div className="timeline-content">
                                <h3>Анхны томоохон төсөл</h3>
                                <p>Анхны томоохон төсөл хөтөлбөрүүдийг хэрэгжүүлж, нийгмийн салбарт чухал хувь нэмэр оруулсан.</p>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-year">2000</div>
                            <div className="timeline-content">
                                <h3>Олон улсын хамтын ажиллагаа</h3>
                                <p>Олон улсын түнш байгууллагуудтай хамтран ажиллах боломж бүрдэж, хүрээгээ тэлсэн.</p>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-year">2010</div>
                            <div className="timeline-content">
                                <h3>Шинэ эриний эхлэл</h3>
                                <p>Технологийн дэвшилтэй хамтран ажиллах болж, илүү үр дүнтэй үйл ажиллагаа явуулах боломжтой болсон.</p>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-year">2020</div>
                            <div className="timeline-content">
                                <h3>Орчин үеийн шинэчлэл</h3>
                                <p>Цахим систем, дижитал шийдлүүдийг нэвтрүүлж, үйлчилгээгээ сайжруулсан.</p>
                            </div>
                        </div>
                    </div>

                    <div className="history-stats">
                        <div className="stat-item">
                            <div className="stat-number">30+</div>
                            <div className="stat-label">Жилийн туршлага</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">100+</div>
                            <div className="stat-label">Амжилттай төсөл</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">50+</div>
                            <div className="stat-label">Түнш байгууллага</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">10000+</div>
                            <div className="stat-label">Үйлчлүүлэгч</div>
                        </div>
                    </div>

                    <div className="history-mission">
                        <div className="mission-content">
                            <h2>Бидний Эрхэм Зорилго</h2>
                            <p>
                                Монгол Авто Тээврийн Нийгэмлэг нь авто тээврийн салбарын хөгжилд хувь нэмэр оруулах,
                                гишүүдэдээ чанартай үйлчилгээ үзүүлэх, нийгмийн хариуцлагатай байгууллага байхыг
                                эрхэм зорилгоо болгодог.
                            </p>
                            <div className="mission-values">
                                <div className="value-item">
                                    <h4>Чанар</h4>
                                    <p>Бид үйлчилгээний өндөр чанарыг тэргүүнд тавьдаг</p>
                                </div>
                                <div className="value-item">
                                    <h4>Итгэлцэл</h4>
                                    <p>Хамтран ажилладаг бүх талуудтай нээлттэй харилцааг эрхэмлэдэг</p>
                                </div>
                                <div className="value-item">
                                    <h4>Шинэчлэл</h4>
                                    <p>Тогтвортой хөгжилд чиглэсэн шинэлэг санаа, шийдлүүдийг хэрэгжүүлдэг</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;